export const compareValues = (
  newValue: number | undefined,
  oldValue: number | undefined,
) =>
  newValue !== undefined && oldValue !== undefined ? newValue - oldValue : 0;
